import React, { useState } from "react";
import {
  Button,
  TextField,
  Container,
  Typography,
  Box,
  CircularProgress,
} from "@mui/material";

const Footer = () => {
  return (
    <>
      <Box
        sx={{
          display: `flex`,
          justifyContent: `center`,
          alignItems: `center`,
          py: 2.2,
          //   borderTop: `1px solid #ffffff33`,
          // background: "transparent",
          background: "#191b2f",
          width: "100%",
          zIndex: "2",
          position: "relative",
        }}
      >
        <Box component="a" href={""} className="footer">
          <Typography variant="span" component="span" className="">
            © 2026 MyNetGoals . All rights reserved.
          </Typography>
        </Box>
      </Box>
    </>
  );
};

export default Footer;
